import { getCurrentClientConfig } from "config/clientConfig";

const currentClientConfig = getCurrentClientConfig();

const endpoints = {
  // Base URLs
  API_BASE_URL: currentClientConfig.apiBaseUrl,

  // Store
  HOME: "/store/home",
  ALLPRODUCTS: "/store/products",
  PRODUCT_BY_DETAILS_ID: (id) => `/store/products/${id}`,
  PRODUCTS_BY_CATEGORY: (categoryId) => `/store/products/by-category/${categoryId}`,
  PRODUCTS_BY_SEARCH: "/store/products/search",
  SEARCH_ADVANCED: "/store/products/search-advanced",
  PUBLIC_ORDER_TOKEN: "/public/order-token",
  PUBLIC_ORDERS: "/public/orders",
  PUBLIC_ORDER_BY_ID: (orderId) => `/public/orders/${orderId}`,

  // Categories
  CATEGORIES: "/categories",
  SUBCATEGORIES: (categoryId) => `/categories/${categoryId}/subcategories`,

  // Admin auth
  LOGIN: "/admin/login",

  // Admin products
  ADMIN_PRODUCT_BY_ID: (id) => `/admin/products/${id}`,
  CREATEPRODUCTS: "/admin/products",
  UPDATEPRODUCTS: (productId) => `/admin/products/${productId}`,
  DELETEPRODUCTS: (productId) => `/admin/products/${productId}`,
  PRODUCTS_BY_SEARCH_ADMIN: "/admin/products/search",

  // Admin categories
  CREATECATEGORY: "/admin/categories",
  UPDATECATEGORY: (categoryId) => `/admin/categories/${categoryId}`,
  DELETECATEGORY: (categoryId) => `/admin/categories/${categoryId}`,

  // Admin banners
  CREATEBANNER: "/admin/banners",
  UPDATEBANNER: (bannerId) => `/admin/banners/${bannerId}`,
  TOGGLEACTIVE: (bannerId) => `/admin/banners/${bannerId}/toggle-active`,

  // Admin videos
  CREATEVIDEO: "/admin/videos",
};

export default endpoints;
